// src/belediye/components/mesajlasma/TaskFlowPanel.js
// G9/G10: Kişi seçilip "Sohbet Başlat" denince THREAD (sohbet ekranı) alanında
// açılan GEÇİCİ görev-akışı. conversation HENÜZ OLUŞMAZ (listede/sidebar'da iz yok).
// Ekran GERÇEK SOHBET GİBİ görünür: üstte BOŞ sohbet alanı, ALTTA (mesaj kısmının
// hizasında) sırayla:
//   1) 3 SEÇENEK (Hızlı Görev / Görev Ata / Başvuru Ata) — görev-menüsü/askOpen
//      panelleriyle AYNI konumda (mesaj alanının üzerinde), yukarıda DEĞİL.
//   2) seçilince TaskComposer — adım-adım sorular (metin alttaki mesaj kutusundan).
//   3) görev/başvuru oluşunca gerçek sohbet doğar → onStarted(convId).
import React, { useState } from "react";

// FAZ-51: görev ikonu TEK sözlükten (kavram değişince her yer değişsin)
import { TaskIcon } from "../icons/appIcons";
import { useNavigate } from "react-router-dom";

import TaskLauncher from "./TaskLauncher";
import TaskComposer from "./TaskComposer";
// FAZ-52: "Başvuru Ata" akışı (mevcut başvuruyu ata → başvuru sayfasına git)
import BasvuruAtaPanel from "./BasvuruAtaPanel";

export default function TaskFlowPanel({ targets = [], unitTarget = null, onStarted, onClose }) {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null); // null=seçenekler | "hizli"|"detayli"|"basvuru"

  const done = (task) => {
    if (task?.conversation_id) {
      onStarted && onStarted(task.conversation_id); // görevin kendi sohbeti doğdu → geç
    } else if (task?.id) {
      navigate(`/yonetim/gorevler/${task.id}`); // köprü kapalı — görev detayına
      onClose && onClose();
    } else if (onClose) {
      onClose();
    }
  };

  // Alt panel (mesaj kısmının hizasında): seçenekler → composer.
  let altPanel;
  if (mode === "basvuru") {
    // FAZ-52: "yakında" placeholder'ı kalktı — akış yazıldı (mevcut başvuruyu
    // ata). Atama bitince BAŞVURU sayfasına gidilir, sohbet kapanır.
    altPanel = (
      <BasvuruAtaPanel
        targets={targets}
        onCancel={() => setMode(null)}
        onDone={() => onClose && onClose()}
      />
    );
  } else if (mode) {
    altPanel = (
      <TaskComposer
        mode={unitTarget ? "detayli" : mode}
        targets={targets}
        unitTarget={unitTarget}
        conversationId={null} // kaynak sohbet YOK — kart görevin KENDİ sohbetine düşer (G8)
        onCancel={() => setMode(null)}
        onDone={done}
      />
    );
  } else {
    altPanel = <TaskLauncher targets={targets} unitTarget={unitTarget} onBack={onClose} onPickMode={setMode} />;
  }

  return (
    <div className="msj-thread-taskflow">
      {/* Üstte BOŞ sohbet alanı — henüz mesaj yok (görev oluşunca dolacak). */}
      <div className="msj-taskflow-fill">
        <TaskIcon className="msj-empty-icon" />
        <span>
          {mode
            ? "Soruları yanıtlayın — talep oluşunca sohbet burada başlayacak."
            : "Aşağıdan bir işlem seçin — talep oluşunca sohbet burada başlayacak."}
        </span>
      </div>
      {/* ALTTA (mesaj kısmının üzerinde) seçenek/soru paneli. */}
      <div className="msj-taskflow-panel">{altPanel}</div>
    </div>
  );
}
